import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import SupplierContent from '../components/suppliers/SupplierContent';
import SupplierForm from '../components/suppliers/SupplierForm';
import suppliersHero from '../assets/images/hero/supplier.png';

const Suppliers = () => {
  return (
    <div>
      <SEO 
        title="Suppliers | Partner with Grace Super Market"
        description="Become a supplier for Grace Super Market. Partner with Chennai's leading retail chain and grow your business with us."
        keywords="Grace Super Market suppliers, vendor registration, retail partnership, business opportunities"
        ogImage={suppliersHero}
        canonicalUrl={`${process.env.REACT_APP_CURRENT_URL}/suppliers`}
      />
      <HeroSection 
        title="Partner With Us" 
        description="Feel free to reach out for a synergistic collaboration"
        image={suppliersHero}
      />
      <section className="py-12">
        <div className="container mx-auto px-8">
          <div className="flex flex-col md:flex-row gap-8">
            <SupplierContent />
            <SupplierForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Suppliers;